import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/HomeSections.tsx");
